export const voiceContent = {
  he: {
    title: "פיתוח קול בבת ים",
    subtitle: "שיעורים אישיים בסטודיו ביתי — שירה, פרפורמנס ואמנות הבמה.",

    bulletsTop: ["שירה", "פרפורמנס", "אמנות הבמה"],

    ctaPrimary: "לתיאום שיחת היכרות",
    ctaSecondary: "איך זה עובד?",

    kicker1: "מהות",
    kicker2: "למי זה מתאים",
    kicker3: "תהליך",
    kicker4: "קצת על אתל",
    kicker5: "שאלות נפוצות",
    kicker6: "הרשמה",

    section1Title: "מה עושים כאן",
    section1Text:
      "עבודה פרקטית על קול, נשימה, ביטחון והגשה.\nתהליך אישי, מדויק ונעים — בקצב שלך, בלי לחץ.",

    section2Title: "למי זה מתאים",
    section2List: [
      "מי שרוצה לשיר בביטחון",
      "זמרים / זמרות",
      "ראפרים – כולל עבודה על טקסט וכתיבה",
      "יוצרים ויוצרות",
      "הכנה לבמה ולאודישנים",
      "הפקת שירה לאולפן הקלטות",
    ],

    section3Title: "איך זה עובד",
    section3Steps: [
      { title: "שיחת היכרות קצרה", text: "מבינים מטרות, רקע, ומה בא לך לשפר." },
      { title: "שיעור ראשון", text: "אבחון עדין + תרגול מעשי + כיוון אישי." },
      { title: "תהליך", text: "בניית שגרה ותרגילים שמתאימים לקול ולקצב שלך." },
    ],

    section4Title: "קצת על אתל",
    section4Name: "אתל פייגמן",
    section4Text:
      "זמרת פרפורמרית ומורה לפיתוח קול, בעלת ניסיון של 15 שנים בהוראה ובהפקת שירה לזמרים.\nעובדת עם אנשים שרוצים להתחבר לקול שלהם, להרגיש חופשיים יותר בביצוע ולהביא נוכחות לבמה ולאולפן.",

    faqTitle: "שאלות נפוצות",
    faq: [
      {
        q: "צריך ניסיון קודם?",
        a: "לא. מתחילים מאיפה שאתה/את נמצאים.",
      },
      {
        q: "זה מתאים גם לראפרים?",
        a: "כן. העבודה כוללת הגשה, ביטחון, קצב, נשימה וגם עבודה על טקסט וכתיבה לפי הצורך.",
      },
      {
        q: "איפה זה?",
        a: "בבת ים — בסטודיו ביתי ונעים. כתובת מדויקת נשלחת אחרי תיאום.",
      },
    ],

    formTitle: "השאירו פרטים",
    formNote: "ממלאים את הטופס ואנחנו חוזרים אליך בהקדם.",

    footer: "© YEN SOUND",
  },

  ru: {
    title: "Вокал в Бат-Яме",
    subtitle: "Индивидуальные занятия в домашней студии — вокал, перформанс и сценическое искусство.",

    bulletsTop: ["Вокал", "Перформанс", "Сцена"],

    ctaPrimary: "Записаться на знакомство",
    ctaSecondary: "Как это работает?",

    kicker1: "Суть",
    kicker2: "Кому",
    kicker3: "Шаги",
    kicker4: "Об Этель",
    kicker5: "FAQ",
    kicker6: "Заявка",

    section1Title: "Что мы делаем",
    section1Text:
      "Практическая работа с голосом, дыханием, уверенностью и подачей.\nЛичный, точный и спокойный процесс — в твоём темпе, без давления.",

    section2Title: "Кому подойдёт",
    section2List: [
      "Тем, кто хочет петь увереннее",
      "Певцам и певицам",
      "Рэп-артистам — включая работу с текстом и написанием",
      "Авторам и артистам",
      "Подготовка к сцене и кастингам",
      "Вокальная продакшн-работа для студии звукозаписи",
    ],

    section3Title: "Как это работает",
    section3Steps: [
      { title: "Короткое знакомство", text: "Обсуждаем цели, опыт и что хочется улучшить." },
      { title: "Первый урок", text: "Мягкая диагностика + практика + индивидуальный план." },
      { title: "Процесс", text: "Строим привычки и упражнения под твою реальность." },
    ],

    section4Title: "Об Этель",
    section4Name: "Этель Файгман",
    section4Text:
      "Певица, перформер и преподаватель вокала с 15-летним опытом работы с вокалистами и артистами.\nПомогает раскрыть голос, чувствовать свободу в исполнении и уверенно звучать на сцене и в студии.",

    faqTitle: "FAQ",
    faq: [
      {
        q: "Нужен ли опыт?",
        a: "Нет. Начинаем с твоего уровня — спокойно и понятно.",
      },
      {
        q: "Подходит ли это рэперам?",
        a: "Да. Работа включает подачу, ритм, дыхание, уверенность, а также работу с текстом и написанием при необходимости.",
      },
      {
        q: "Где проходят занятия?",
        a: "Бат-Ям — в уютной домашней студии. Точный адрес отправим после записи.",
      },
    ],

    formTitle: "Оставьте контакты",
    formNote: "Заполните форму — мы свяжемся с вами в ближайшее время.",

    footer: "© YEN SOUND",
  },
};
